const SHARE_ERRORS = {
    saveShareSettingsMutationErrorMessage: 'The share settings mutation failed with an error in the response.',
    saveShareSettingsServerErrorMessage: 'The share settings operation failed with a server error.'
};

export class SaveShareSettingsMutationError extends Error {
    constructor(message?: string) {
        super(message || SHARE_ERRORS.saveShareSettingsMutationErrorMessage);
        this.name = 'SaveShareSettingsMutationError';
    }
}

export class SaveShareSettingsServerError extends Error {
    constructor(message?: string) {
        super(message || SHARE_ERRORS.saveShareSettingsServerErrorMessage);
        this.name = 'SaveShareSettingsServerError';
    }
}
